<template>
  <div class="company_box">
    <el-Row>
      <el-col style="padding:10px">
        <el-input placeholder="请输入您要查找的热力公司" @keyup.native="filterList" v-model.trim="filterVal">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </el-col>
    </el-Row>
    <div v-if="!flagFilter" class="list">
      <li
        v-for="(item,ind) in cityList"
        @click="getValue(item)"
        :class="item.code==companyCode?'company_item':'company_item'"
        :key="ind"
      >
        {{item.name}}
        <i v-if="item.code==companyCode" class="company_icon el-icon-check"></i>
      </li>
    </div>
    <div v-if="flagFilter" class="list">
      <li
        v-for="(item,ind) in filterItem"
        @click="getValue(item)"
        :class="item.code==companyCode?'company_item':'company_item'"
        :key="ind"
      >
        {{item.name}}
        <i v-if="item.code==companyCode" class="company_icon el-icon-check"></i>
      </li>
    </div>
    <div v-if="filterItem.length==0&&flagFilter" class="list">
      <li class="company_item">未搜索到结果</li>
    </div>
    <p v-if="cityList.length==0&&!flagFilter" class="no_data">暂无数据</p>
  </div>
</template>
<script>
import { getReli, saveReli, getBindReli } from "@/api";
export default {
  data() {
    return {
      cityList: [],
      companyCode: "",
      filterVal: "",
      filterItem: [],
      flagFilter: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getValue(item) {
      const params = {
        companyName: item.name,
      };
      saveReli(params).then((res) => {
        sessionStorage.setItem("companyCode", item.code);
        this.$router.push(sessionStorage.getItem("path"));
      });
    },
    getList() {
      getReli().then((res) => {
        this.cityList = res.data;
        if (sessionStorage.getItem("thirdId")) {
          this.getBindReli();
        }
      });
    },
    getBindReli() {
      getBindReli(sessionStorage.getItem("thirdId")).then((res) => {
        sessionStorage.setItem("companyCode", res.data.companyCode);
        this.companyCode = res.data.companyCode;
      });
    },
    filterList(val) {
      if (this.filterVal.length > 0) {
        this.flagFilter = true;
        this.filterItem = this.cityList.filter((item) => {
          return item.name.indexOf(this.filterVal) != -1;
        });
      } else {
        this.flagFilter = false;
      }
    },
  },
};
</script>

<style scoped>
.company_box {
  /* background: #fff; */
  min-height: 90%;
  width: 100%;
}
.company_item {
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
  line-height: 55px;
  padding: 0 3%;
  font-size: 17px;
  font-weight: 550;
}
.active_item {
  color: #1890ff;
}
.company_icon {
  color: #1890ff;
  font-size: 20px;
  font-weight: bold;
}
.no_data {
  text-align: center;
  line-height: 500px;
  color: #666565;
}
</style>



// WEBPACK FOOTER //
// src/view/yhBind/bindComponey.vue